export * from './TTooltipDesktopTheme';
export * from './ITooltipDesktopProps';